import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { featureEnabled } from 'utils';
import { Menu as AntdMenu } from 'antd';
import { AuthContext } from 'contexts';
import Icon from '../../Icon';
import { StyledMenu } from '../StyledComponents';
import { StyledMenuProps } from './types';

const AnsweringMenu: React.FC<StyledMenuProps> = ({
  selectedKey,
  disableToolTip,
  renderBadgeItem,
  getIconColor,
}) => {
  const { auth } = useContext(AuthContext);
  const features = auth?.org.features;
  const useEnhancedAnswering = useMemo(
    () => auth?.org.type === 'answering' || auth?.org.type === 'mlsStaff',
    [auth],
  );
  const menuText = useEnhancedAnswering ? 'Search' : 'Brokerages';

  return (
    <StyledMenu
      mode="inline"
      selectedKeys={[selectedKey]}
      $hasSupraRebrandingFeature={featureEnabled('supraRebrandingFeature', 1)}
    >
      {renderBadgeItem('queue', '/answering/queue')}
      <AntdMenu.Item
        key="1"
        icon={
          <Icon
            type={useEnhancedAnswering ? 'search' : 'home'}
            color={getIconColor('1')}
            offset={[0, 2]}
          />
        }
        title={disableToolTip ? null : menuText}
        data-cy="side-menu-brokerages"
      >
        <Link to={`/answering/${menuText.toLowerCase()}`}>
          <span>{menuText}</span>
        </Link>
      </AntdMenu.Item>
      {(!featureEnabled('orgAdminFeature') || features.includes('ADMIN')) && (
        <AntdMenu.Item
          key="2"
          icon={<Icon type="tool" color={getIconColor('2')} />}
          title={disableToolTip ? null : 'Settings'}
          data-cy="side-menu-settings"
        >
          <Link to="/answering/settings">
            <span>Settings</span>
          </Link>
        </AntdMenu.Item>
      )}
    </StyledMenu>
  );
};

export default AnsweringMenu;
